import React, { forwardRef } from 'react';

import { COLORS } from '../../../tokens/colors';
import * as ST from './styled';

export const btnTypes = {
    PRIMARY: 'primary',
    ACCENT: 'accent',
    SECONDARY: 'secondary',
    WHITE: 'white',
    GHOST: 'ghost',
};

export const btnSizes = {
    LARGE: 'large',
    MIDDLE: 'middle',
    SMALL: 'small',
};

export const sizes = {
    large: {
        vPadding: 12,
        hPadding: 24,
        iconPadding: 12,
        iconSize: 24,
        ratio: 0.83,
    },
    middle: {
        vPadding: 8,
        hPadding: 24,
        iconPadding: 8,
        iconSize: 24,
        ratio: 0.90,
    },
    small: {
        vPadding: 8,
        hPadding: 16,
        iconPadding: 6,
        iconSize: 24,
        ratio: 0.89,
    },
};

/**
 * @deprecated
 */
export const BaseButton = forwardRef(({
    type = 'primary',
    size,
    text,
    price,
    iconsSprite,
    symbolId,
    iconTitle,
    href,
    className,
    isLoading,
    disabled,
    isRotatedIcon,
    onClick,
    children,
    ...rest
}, ref) => {
    const elementType = href ? 'a' : 'button';

    const isOnlyIcon = symbolId && !text && !children;

    return (
        <ST.Button
            ref={ref}
            as={elementType}
            type={type}
            size={size}
            href={href}
            className={className}
            isLoading={isLoading}
            disabled={disabled}
            onClick={disabled || isLoading ? () => null : onClick}
            isOnlyIcon={isOnlyIcon}
            isIcon={!!symbolId}
            {...rest}
        >
            {iconsSprite && symbolId &&
                <ST.IconWrap isOnlyIcon={isOnlyIcon} isRotatedIcon={isRotatedIcon} size={size}>
                    <svg width={sizes[size]?.iconSize} height={sizes[size]?.iconSize} role='img'>
                        <title>{iconTitle || symbolId}</title>
                        <use href={`${iconsSprite}#${symbolId}`}/>
                    </svg>
                </ST.IconWrap>
            }

            <ST.Inner isPrice={!!price} isLoading={isLoading}>
                {!isLoading
                    ? children
                        ? children
                        : <>
                            <span>{text}</span>
                            {price && <span>{price}</span>}
                        </>
                    : <ST.SThrobber
                        color={type === btnTypes.PRIMARY || type === btnTypes.ACCENT ? COLORS.TextWhite : COLORS.ButtonAccent}
                        isLoading={true}
                    />
                }
            </ST.Inner>
        </ST.Button>
    );
});

BaseButton.displayName = 'BaseButtonWithForwardedRef';
